import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-badge",
  templateUrl: "./badge.component.html",
  styleUrls: ["./badge.component.scss"],
})
export class BadgeComponent implements OnInit {
  @Input()
  set color(color: string) {
    this._color = color || "#000000";
  }
  get color() {
    return this._color;
  }
  _color: string = "";

  @Input() badgeClass = "";

  @Input()
  set text(value: string) {
    if (!value) return;
    this._text = value
      .split(" ")
      .map((word) => word[0]?.toUpperCase())
      .join("");
  }
  get text() {
    return this._text;
  }
  _text: string = "";

  constructor() {}

  ngOnInit(): void {}
}
